// src/com/tsr/TsrStyle.js

export const TsrPageStyle = {
    background: 'white',
    width: '21cm',
    height: '29.7cm',
    display: 'block',
    margin: '0 auto',
    marginBottom: '0.5cm',
    boxShadow: '0 0 0.5cm rgba(0,0,0,0.5)',
    fontFamily: 'SeoulNamsanMWeb',
};

export const TsrStyles = {
    div60x4: {width:"60mm",height:'4mm'},
    div65x4: {width:"65mm",height:'4mm'},
    divSign: {borderBottom: '1px solid', width: '31mm'}, // border-bottom: 1px solid; width:31mm
    noTopMargin: {marginTop: '0mm'},
    topMargin1mm: {marginTop: '1mm'},
    topMargin2mm: {marginTop: '2mm'},
    font12px: {fontSize: '12px'},
    font11px: {fontSize: '11px'},
    width25mm: {width: '25mm'},
    width40mm: {width: '40mm'},
    width60mm: {width: '60mm'},
    width65mm: {width: '65mm'},
    width80mm: {width: '80mm'},
};

// return yyyyMMdd HHmm (from yyyy-mm-dd HH:mm:ss)
export function tsrDateTime(dateTime) {
    if(dateTime) return dateTime.substring(0, 16); //.replace(/[-:]/g, '');
    return '';
}

export function tsrLetter(text, idx) {
    if(text && text.length > idx) return text[idx];
    return '';
}

export function tsrTemperature(temp) {
    if(temp === 'off') return 'off';
    if(temp !== null && temp !== undefined)
        return temp + ' ℃';
    return '';
}

export function tsrNumber(num) {
    return num >0 ? num : '';
}

export function tsrStoreIdPlusVehPlates(tsrData) {
    if(!tsrData.storeId) return '';
    // storeId : padd zeros to make 4 digits
    const storeId4 = tsrData.storeId.padStart(4, '0');
    // get last 4 digits of vehPlates
    const vehPlates4 = tsrData.vehPlates.slice(-4);
    return `${storeId4}${vehPlates4}`;
}
